/** @jsxImportSource @emotion/react */
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-regular-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';
import { searchGreySvg } from '../assets/images';
import { actionCreators } from '../reducers/resources';
import { SideBarAccordion } from '../components/BaseComponents';
import { StateShape as ReduxStateShape } from '../reducers';

const ResourcePickerLayer = () => {
    const [resourcesSearch, setResourcesSearch] = useState('');
    const [accordionActiveKeys, setAccordionActiveKeys] = useState(['0']);
    const { selectedResourcePickerValue, resourcePickerValues } = useSelector(
        (state: ReduxStateShape) => ({
            ...state.resources,
        })
    );

    const dispatch = useDispatch();
    const i18n = commonHooks.useLocalization();
    const locale = i18n.getLocale();

    const onClickRow = (r: string) => {
        dispatch(actionCreators.setSelectedResourcePickerValue(`{{ resourceStrings.${r} }}`));
    };

    const onClickClose = () => {
        dispatch(actionCreators.setIsShowResourcePicker(false));
        selectedResourcePickerValue?.length &&
            dispatch(actionCreators.setSelectedResourcePickerValue(null));
    };

    // Handles search functioanlity for widgets
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setResourcesSearch(e.target.value);

        if (!e.target.value.trim().length) {
            return;
        }

        const AccordionDivs = document.querySelectorAll<HTMLElement>('.resource-picker-accordion');
        const AccordionTitle = document.querySelectorAll<HTMLElement>(
            '.resource-picker-accordion-toggle'
        );
        const activeAccordions = [...accordionActiveKeys];

        Array.from(AccordionDivs).forEach((node: any) => {
            if (node.textContent!.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0) {
                node.style.display = 'block';
                Array.from(AccordionTitle).forEach((node: any, index: any) => {
                    const AccordionData = node.nextSibling.querySelectorAll('.resource');

                    if (
                        node.textContent!.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
                    ) {
                        if (!activeAccordions.includes(`${index}`)) {
                            activeAccordions.push(`${index}`);
                        }

                        Array.from(AccordionData).forEach((node: any) => {
                            node.style.display = 'flex';
                        });
                    } else {
                        Array.from(AccordionData).forEach((node: any) => {
                            if (
                                node
                                    .textContent!.toLowerCase()
                                    .indexOf(e.target.value.toLowerCase()) >= 0
                            ) {
                                if (!activeAccordions.includes(`${index}`)) {
                                    activeAccordions.push(`${index}`);
                                }

                                node.style.display = 'block';
                            } else {
                                node.style.display = 'none';
                            }
                        });
                    }
                });
            } else {
                node.style.display = 'none';
            }
        });

        if (!e.target.value.length) {
            setAccordionActiveKeys(['0']);
        } else {
            setAccordionActiveKeys(activeAccordions);
        }
    };

    const onClickAccordion = (eventKey: string) => {
        if (accordionActiveKeys.includes(eventKey)) {
            setAccordionActiveKeys(accordionActiveKeys.filter((k) => k !== eventKey));
        } else if (eventKey) {
            setAccordionActiveKeys([eventKey]);
        }
    };

    return (
        <div className="resource-picker-layer">
            <div className="header">
                <h3 className="title">Resources</h3>
                <button className="close-button" onClick={onClickClose}>
                    <FontAwesomeIcon icon={faXmarkCircle} />
                </button>
            </div>
            <div className="resources-container">
                <div className="input-search-resource">
                    <img src={searchGreySvg} alt="Search icon" />
                    <input
                        type="text"
                        placeholder="All Resources"
                        value={resourcesSearch}
                        onChange={handleChange}
                        className={'input-textfield'}
                    />
                </div>
                <div className="resources-list">
                    {resourcePickerValues &&
                        Object.keys(resourcePickerValues).map((key, index) => (
                            <div key={`${key}-${index}`}>
                                {resourcePickerValues?.[key]?.[locale] &&
                                    Object.keys(resourcePickerValues?.[key]?.[locale])?.length >
                                        0 && (
                                        <SideBarAccordion
                                            toggleTitle={i18n.t(`${key}_resources_title`)}
                                            eventKey={index.toString()}
                                            key={index}
                                            className="resource-picker-accordion"
                                            toggelClassName="resource-picker-accordion-toggle"
                                            accordionActiveKey={accordionActiveKeys}
                                            onClickAccordion={onClickAccordion}
                                        >
                                            <>
                                                {Object.keys(
                                                    resourcePickerValues?.[key]?.[locale]
                                                ).map((k, i) => {
                                                    return (
                                                        <div
                                                            className={`resource`}
                                                            key={`${k}-${i}`}
                                                            onClick={() => onClickRow(k)}
                                                        >
                                                            <p
                                                                className={'resource-key'}
                                                            >{`${k}`}</p>
                                                            <p className={'resource-value'}>
                                                                {
                                                                    resourcePickerValues?.[key]?.[
                                                                        locale
                                                                    ]?.[k]
                                                                }
                                                            </p>
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        </SideBarAccordion>
                                    )}
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default ResourcePickerLayer;
